export default "__VITE_ASSET__cK3NUQ31__"